var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{ref:_vm.refPrefix,staticClass:"app-common-textarea",class:{
    'no-resize': !_vm.resize,
    'no-pointer-events': _vm.readonly
  },style:(_vm.userStyle),attrs:{"readonly":_vm.readonly,"rows":_vm.rows,"maxlength":_vm.maxlength,"placeholder":_vm.placeholder,"disabled":_vm.disabled},domProps:{"value":_vm.remarks},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }